/**
 * What `enrolIfEligible`, `resumeEnrolment` and `retryRecovery` can answer
 * (`enrolment.js`, which re-exports both). Their own file so that callers and
 * specs that only compare outcomes need none of the machinery behind them.
 */

/** What one call to `enrolIfEligible` can end as. */
export const ENROLMENT_OUTCOME = Object.freeze({
  /**
   * The bundle is registered and this device holds MK. `resumed: true` when
   * an attempt sent earlier was finalised from a status read rather than a
   * fresh 201 — the same bundle, the same key.
   */
  ENROLLED: 'enrolled',
  /** A precondition said no; `reason` says which. Nothing was sent. */
  SKIPPED: 'skipped',
  /**
   * The API said not now: 503, or a conflict whose status read showed no
   * bundle. The attempt is kept and re-sent after RETRY_AFTER_MS.
   */
  DEFERRED: 'deferred',
  /** 404: the flag is off on the API. The attempt is kept; stop asking. */
  FLAG_OFF: 'flag-off',
  /** A status read proved a different bundle, or a revoke: hand over to device approval. */
  ENROLLED_ELSEWHERE: 'enrolled-elsewhere',
  /** Anything else. The attempt is kept; retried on the next Hub open. */
  ERROR: 'error',
});

/** Why a `SKIPPED` outcome skipped. */
export const SKIP_REASON = Object.freeze({
  FLAG_OFF: 'flag-off',
  NOTES_UNAVAILABLE: 'notes-unavailable',
  NOT_HYDRATED: 'not-hydrated',
  NO_MEMBER: 'no-member',
  ALREADY_HAS_KEY: 'already-has-key',
  NOT_ELIGIBLE: 'not-eligible',
  NOT_PERSISTENT: 'not-persistent',
  /** A 503 or an uninterpretable 409 within the retry window: waiting, not nagging. */
  DEFERRED: 'deferred',
  /** A 404 earlier in this session: the API's flag is off. */
  SERVER_FLAG_OFF: 'server-flag-off',
  /** The API refused the body earlier this session. Kept; re-sent once next launch. */
  ATTEMPT_REJECTED: 'attempt-rejected',
  /** `resumeEnrolment` found nothing sent to reconcile. */
  NO_ATTEMPT: 'no-attempt',
});
